var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddProfessional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 6V1.33333C18.6667 0.6 18.0667 0 17.3333 0H1.33333C0.6 0 0 0.6 0 1.33333V14.6667C0 15.4 0.6 16 1.33333 16H17.3333C18.0667 16 18.6667 15.4 18.6667 14.6667V10L24 15.3333V0.666667L18.6667 6ZM14.6667 9.33333H10.6667V13.3333H8V9.33333H4V6.66667H8V2.66667H10.6667V6.66667H14.6667V9.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddProfessional);
export default __webpack_public_path__ + "static/media/iconAddProfessional.a7081036d37b873dd1b2d08721089869.svg";
export { ForwardRef as ReactComponent };